// @module BRAccessible
define('BRAccessible.View', ['braccessible.tpl', 'BRAccessible.SS2Model', 'Backbone'], function (
	braccessible_tpl,

	BRAccessibleSS2Model,

	Backbone
) {
	'use strict';

	// @class BRAccessible.View @extends Backbone.View
	return Backbone.View.extend({
		template: braccessible_tpl,

		initialize: function (options) {
			/*  Uncomment to test backend communication with an example service
				(you'll need to deploy and activate the extension first)
			*/
			// this.model = new BRAccessibleModel();
			// var self = this;
			// this.model.fetch().done(function(result) {
			// 	self.message = result.message;
			// 	self.render();
			// });
		},

		events: {},

		bindings: {},

		childViews: {},

		//@method getContext @return BRAccessible.View.Context
		getContext: function getContext() {
			//@class BRAccessible.View.Context
			this.message = this.message || 'Hello World!!';
			return {
				message: this.message
			};
		}
	});
});
